module.exports = __webpack_public_path__ + "static/media/sfc prototype.c05f52f8.gif";